import Api from '../api/reconApi.js';
import AUTH_API, { AUTH_API_URLS } from '../api/authApi'
import HomeInfo from '../api/HomeInfo';
import setAuthorizationToken from '../api/setAuthorizationToken';
import * as getInfo from './apiGetInfo';
import * as setInfo from './apiSetInfo';
import * as AllMutates from './AllMutates';
import * as types from './types'
import { store } from '../index.js'


function errorReport(data, type = 'login') {
	const errors = {};

	if (type === 'login') {
		errors.loginError = 'Username or Password is incorrect';
	} else if (type === 'reset_password') {
		errors.loginError = 'Sorry, this Reset Link is no longer active. Please issue another request below.';
	} else if (type === 'forgotpassword') {
		errors.loginError = 'Sorry, Username/Email was not found. Please contact support if you do not know your username or email on file. Thank you!.';
	}

	return {
		errors,
	};
}

// export function login(email, password) {
// 	return (dispatch) => {
// 		const browser = getInfo.getBrowser();
// 		return Api.login('access_tokens', email, password, `desktop${browser}`)
// 			.then((resp) => {
// 				const { token } = resp.data;
// 				const user = resp.data.user_id;
// 				const username = resp.data.user.user_name;
// 				const userAll = resp.data.user;
// 				localStorage.setItem('reconUserName', JSON.stringify(username));
// 				localStorage.setItem('reconToken', token);
// 				localStorage.setItem('reconUser', user);
//
// 				setAuthorizationToken(token, user, username);
//
// 				dispatch(setInfo.setCurrentUser({ user: userAll, token }));
//
// 				dispatch(getInfo.getDealerships());
// 				return 'logged in';
// 			})
// 			.catch(ex => errorReport(ex, 'login'));
// 	};
// }

export function swapRedirectToken(redirectToken, pkce, onSuccess){
	let headers = {
		Authorization: `bearer ${redirectToken}`,
		Accept: 'application/json',
		'Content-Type': 'application/json',
	}
	AUTH_API(AUTH_API_URLS.SWAP_REDIRECT_TOKEN, {
    method: 'POST',
    headers,
    body: JSON.stringify({ pkce, client_id: 8931252 }),
  })
  .then(response => {
    if (response.status === 200) {
      return response.json()
    } else {
      logout(true)
    }
  })
  .then(res => {
    if (res && res.access_token) {
      getUserLoginInfo(res, onSuccess)
    } else {
      logout(true)
    }
  })
}

/**
 * Development-only sign-in against the local API (`POST {RECON_API_BASE_URL}dev/login`).
 * Must not be used from production builds (route is gated in app.js).
 */
export function devLogin({ email, username } = {}, onSuccess, onError) {
	const base = HomeInfo.baseUrl();
	if (!base) {
		const err = new Error('RECON_API_BASE_URL is not set. Use npm run start-local.');
		if (onError) onError(err);
		return Promise.reject(err);
	}

	const body = {};
	if (email) body.email = email;
	if (username) body.username = username;

	// Do not send credentials: the local API currently reflects
	// Access-Control-Allow-Origin: *, which browsers reject with cookies.
	return fetch(`${base}dev/login`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	})
		.then((response) => {
			if (!response.ok) {
				return response.text().then((text) => {
					let detail = text;
					try {
						const json = JSON.parse(text);
						detail = json.error || json.exception || text;
					} catch (e) {
						// keep raw body
					}
					throw new Error(`Dev login failed (${response.status}): ${detail}`);
				});
			}
			return response.json();
		})
		.then((res) => {
			if (res && res.access_token) {
				return getUserLoginInfo(res, onSuccess, onError);
			}
			throw new Error('Dev login response missing access_token');
		})
		.catch((err) => {
			if (onError) {
				onError(err);
				return;
			}
			throw err;
		});
}

function persistUserLogin(auth, userAll, onSuccess) {
	const user = userAll.id;
	const username = userAll.user_name;
	localStorage.setItem('reconUserName', JSON.stringify(username));
	localStorage.setItem('reconToken', auth.access_token);
	localStorage.setItem('reconUser', user);
	setAuthorizationToken(auth.access_token, user, username);
	store.dispatch(setInfo.setCurrentUser({ user: userAll, token: auth.access_token }));
	store.dispatch(getInfo.getDealerships());
	const authentication = {
		...auth,
		user: { ...userAll },
	};
	localStorage.setItem('authentication', JSON.stringify(authentication));
	store.dispatch({
		type: types.UPDATE_USER_LOGIN_INFO,
		authentication,
	});
	if (onSuccess) {
		onSuccess();
	}
}

export function getUserLoginInfo(auth, onSuccess, onError) {
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  if (auth) {
    if (auth.access_token) {
      headers['Authorization'] = `bearer ${auth.access_token}`
    }
  } else {
    let oldAuthentication = localStorage.getItem('authentication')
    if (oldAuthentication) {
      auth = JSON.parse(oldAuthentication)
    }
  }
	if (!auth || !auth.access_token) {
		const err = new Error('No access_token to load user');
		if (onError) onError(err);
		return Promise.reject(err);
	}

	return Api.getUserInfo(auth.access_token).then((response) => {
		if (response && response.status === 200) {
			return response.data;
		}
		throw new Error(`getuser failed (${response && response.status})`);
	}).then((res) => {
		if (res && res.data && res.data.id) {
			persistUserLogin(auth, res.data, onSuccess);
			return;
		}
		throw new Error('getuser response missing user');
	}).catch((error) => {
		if (HomeInfo.isLocalDevApi() && auth.user && auth.user.id) {
			persistUserLogin(auth, auth.user, onSuccess);
			return;
		}
		console.log('Error', error);
		if (onError) {
			onError(error);
			return;
		}
		throw error;
	});

  // return AIP_DJAPI(AIP_DJAPI_URLS.DjangoLoginInfo, {
  //   headers,
  // })
  //   .then(response => {
  //     if (response.status === 200) {
  //       return response.json()
  //     }
  //   })
  //   .then(res => {
  //     let authentication = {
  //       ...auth,
  //       user: { ...res },
  //       userInfo: buildDeprecatedUserInfoObject(res, auth.access_token),
  //     }
  //     localStorage.setItem('authentication', JSON.stringify(authentication))
  //     store.dispatch({
  //       type: userConstants.UPDATE_USER_LOGIN_INFO,
  //       authentication,
  //     })
  //     if (onSuccess) {
  //       onSuccess()
  //     }
  //   })
}

// export function updateUserLoginInfo() {
//   return getUserLoginInfo()
// }

export function logout(requireLogin) {
	localStorage.clear()
	if(requireLogin){
		window.location.pathname= '/require-login'
	}
	else{
		const user = {};
		const token = '';
		store.dispatch(setInfo.setCurrentUser({ user, token }));
		store.dispatch({
			type: types.LOGOUT_USER,
		})
	}
}

export function resetAll() {
	return (dispatch, getState) => {
		const { all_users } = getState().settings_users;

		all_users.map((user) => {
			dispatch(forgotpassword(user.user_name));
		});
	};
}

export function forgotpassword(email) {
	let headers = {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	}
	return AUTH_API(AUTH_API_URLS.INITIATE_RESET_PASSWORD, {
    method: 'POST',
    headers,
    body: JSON.stringify({ email }),
  })
  .then(response => {
    if (response.status === 200) {
      return response.json()
		}
  })
	// return () => Api.forgotpassword('password_resets', email)
	// 	.then(() => 'password reset has been sent')
	// 	.catch(ex => errorReport(ex, 'forgotpassword'));
}

export function reset_password(reset_token, password) {
	return () => Api.reset_password(`password_resets/${reset_token}`, password)
		.then(() => 'password has been reset')
		.catch(ex => errorReport(ex, 'reset_password'));
}

export function reset_user_password(reset_token, password) {
	return dispatch => Api.reset_password(`password_resets/${reset_token}`, password)
		.then(() => {
			dispatch(getInfo.getRelatedUsers());
		})
		.catch(ex => errorReport(ex, 'reset_password'));
}

export function changepassword(email) {
	return dispatch => Api.changepassword('password_resets', email)
		.then((resp) => {
			dispatch(getInfo.getRelatedUsers());
		})
		.catch(ex => errorReport(ex, 'changepassword'));
}
